// components/RefundDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography
} from "@mui/material";

const RefundDialog = ({ open, onClose, paymentId, amount, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Refund</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          Are you sure you want to initiate a refund for this transaction?
        </Typography>
        <TextField
          label="Payment ID"
          value={paymentId}
          fullWidth
          margin="normal"
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="Amount (in paise)"
          value={amount}
          fullWidth
          margin="normal"
          InputProps={{ readOnly: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Confirm Refund
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RefundDialog;